export const EXPERT_EMAILS: Record<string, string> = {
    "elvira.pistolesi@holifya.com": "https://calendly.com/elvira-pistolesi",
    "dr.gentilesalvatore@gmail.com": "https://calendly.com/dr-gentilesalvatore",
    "filippobonaldi91@gmail.com": "https://calendly.com/filippobonaldi91",
    "ccruciani44@gmail.com": "https://calendly.com/ccruciani44",
    "tsimbatatiana@gmail.com": "https://calendly.com/tsimbatatiana",
    "fabiana.nutrizionista@gmail.com": "https://calendly.com/fabiana-nutrizionista",
    "eleonoraluvara.nutrizionista@gmail.com": "https://calendly.com/eleonoraluvara-nutrizionista",
    "carolinacolonna94@gmail.com": "https://calendly.com/carolinacolonna94",
    "admin@holifya.com": "https://calendly.com/admin-holifya",
    "alessandra.piccione91@gmail.com": "https://calendly.com/alessandra-piccione91",
    "vittoria.ferla@holifya.com": "https://calendly.com/dr-gentilesalvatore",
};
export const getExpertSchedulingUrl = (email: string): string | null => {
    const url = EXPERT_EMAILS[email ? email.toLowerCase(): ""];

    return url || null;
}